import {
  Box,
  Hidden,
  Logos,
  PrimaryNavigationButton,
  ProductHeader,
  ProductHeaderLogo,
  ProductTitleText,
} from '@cambridgeassessment/cambridge-ui';
import React, { memo, useCallback } from 'react';
import { hot } from 'react-hot-loader/root';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppContext';
import { useStyles } from '../Header/styles';
import routes from '../Pages/routes';
import UserMenu from '../UserMenu/UserMenu';

interface HeaderProps {
  onToggleSidebar?: () => void;
  isAuthenticated?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  onToggleSidebar,
  isAuthenticated,
}) => {
  const { setAppState } = useAppContext();
  const onNavigateTo = useCallback((_e) => {
    setAppState((prevState) => ({
      ...prevState,
      currentPage: 'home_' + Date.now(),
    }));
  }, []);
  const classes = useStyles();

  return (
    <ProductHeader className={classes.headerWrapper} id="header">
      {onToggleSidebar && (
        <Hidden mdUp>
          <PrimaryNavigationButton onClick={onToggleSidebar} />
        </Hidden>
      )}
      <ProductHeaderLogo data-testid="link-button">
        <Link
          to={routes.Home.path}
          onClick={onNavigateTo}
          aria-label="Cambridge Universitypress and Assessment Logo"
        >
          <Logos.CambridgeUniversityPressAndAssessment />
        </Link>
      </ProductHeaderLogo>
      <ProductTitleText>My Cambridge</ProductTitleText>
      <Box ml="auto">{isAuthenticated && <UserMenu />}</Box>
    </ProductHeader>
  );
};

export default hot(memo(Header));
